import React from 'react';
import { Box } from '@mui/material';
import Pagination from '@mui/material/Pagination';
import { MyTablePagination } from './style';
import { ColorsV2, DarkmodeColors } from 'app/constants/color';

function CustomPagination({ pageNo, setPageNo, count, setSelected, setPageSize, pageSize }) {
  const pageCount = Math.ceil(count / pageSize);

  const handleChangeRowsPerPage = event => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    setPageSize(newRowsPerPage);
    setSelected([]);
  };

  const handlePageChange = value => {
    setPageNo(value);
  };

  // useEffect(() => {
  //   setPageNo(page);
  // }, [page]);

  return (
    <Box
      sx={{
        borderTop: `2px solid ${ColorsV2.white}`,
        width: '100%',
        paddingTop: '10px',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
      }}
    >
      <MyTablePagination
        component='div'
        count={count}
        page={pageNo}
        onPageChange={(event, value) => {
          handlePageChange(value);
        }}
        rowsPerPage={pageSize}
        onRowsPerPageChange={event => {
          handleChangeRowsPerPage(event);
        }}
        rowsPerPageOptions={[10, 20, 50, 100]}
        labelRowsPerPage={''}
        sx={{
          color: 'white',
          '& .MuiIconButton-root': {
            visibility: 'hidden',
          },
          '& .MuiTablePagination-actions': {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            gap: '10px',
          },

          '& .MuiPagination-root': {
            fontSize: '0.6em',
            color: '#8F95B2',
          },

          '& .MuiTablePagination-select': {
            fontSize: '0.8rem',
            fontWeight: 700,
            lineHeight: '1.225rem',
            color: ColorsV2.white,
            border: '2px solid ' + ColorsV2.textInfo,
            borderRadius: '8px !important',
            padding: '5px 10px',
          },

          '&.MuiTablePagination-select option': {
            fontSize: '0.6em',
            fontWeight: 700,
            lineHeight: '24px',
            color: '#8F95B2',
            borderRadius: '8px',
          },
          '&.MuiSelect-root': {
            '& .MuiPaper-root': {
              backgroundColor: DarkmodeColors.appBar,
            },
          },
          '& .MuiSelect-icon': {
            color: 'white',
          },
        }}
        // slotProps={{ toolbar: { fontSize: '30px' } }}
      />

      <Pagination
        shape='rounded'
        // variant='outlined'
        count={pageCount}
        page={pageNo + 1}
        onChange={(event, value) => {
          handlePageChange(value - 1);
          setSelected([]);
        }}
        sx={{
          marginRight: '1.75rem',
          paddingTop: '10px',
          '& .MuiPaginationItem-root': {
            fontStyle: 'normal',
            fontWeight: 700,
            fontSize: '0.6em',
            lineHeight: '24px',
            color: '#8F95B2',
            '&:hover': {
              backgroundColor: 'transparent',
            },
          },
          '& .MuiPaginationItem-outlined': {
            '&.Mui-selected': {
              border: 'none',
              backgroundColor: 'transparent',
              color: ColorsV2.acent,
              fontSize: '1rem',
              fontWeight: 800,
            },
          },
          '& .MuiPaginationItem-icon': {
            border: '1px solid white',
            borderRadius: '8px',
            padding: '5px',
            '&.Mui-disabled': {
              color: '#8F95B2',
            },
          },
          '& .Mui-selected': {
            border: 'none',
            color: ColorsV2.white,
            fontStyle: 'normal',
            fontWeight: 700,
            fontSize: '0.8rem',
            lineHeight: '24px',
            background: 'transparent',
          },
        }}
      />
    </Box>
  );
}

export default React.memo(CustomPagination);
